// actions.js
import * as actionTypes from "./actionsTypes";

export const setValueModeleReserv = (value) => ({
  type: actionTypes.SET_VALUE_ModeleReserv,
  payload: value,
});

export const setTypeModeleReserv = (type) => ({
  type: actionTypes.SET_TYPE_ModeleReserv,
  payload: type,
});
export const setActifModeleReserv = (actif) => ({
  type: actionTypes.SET_ACTIF_ModeleReserv,
  payload: actif,
});

export const setCurrentPageModeleReserv = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE_ModeleReserv,
  payload: page,
});

export const setOrderModeleReserv = (order) => ({
  type: actionTypes.SET_ORDER_ModeleReserv,
  payload: order,
});

export const setSortFieldModeleReserv = (field) => ({
  type: actionTypes.SET_SORT_FIELD_ModeleReserv,
  payload: field,
});
export const setCategorieModeleReserv = (categorie) => ({
  type: actionTypes.SET_CATEGORIE_ModeleReserv,
  payload: categorie,
});
